export function updateCSSVar(varName, value = '') {
    if (!varName) {
        return;
    }

    if (varName.substr(0, 2) !== '--') {
        varName = '--' + varName;
    }

    document.body.style.setProperty(varName, value);
}
